<template>  
  <div class="m-flexContainer ">
    <div class="a-heroImage"></div>
    <div class="m-formContainer ">        
      <form class="m-loginForm" @submit.prevent="submit">        
        <LoadingOverlay :visible="loading" :message="loadingMessage2" />
        <Header :title="title+' V1.0.3.8'" />            
        <div v-if="salesmen == null"  class="m-loginForm__group">
          <div class="a-textInput">
            <input class="a-textInput__element" :class="{ '-animate': animateBorder }" placeholder="ادخل اسم الحساب"
              name="username" type="text" v-model="username" />
            <div class="a-textInput__placeholder">{{ placeholder }}</div>
            <span class="a-textInput__pcAnimation" v-if="animateBorder"></span>
          </div>
        </div>
        <div v-if="salesmen == null" class="m-loginForm__group">
          <div class="a-textInput">
            <input class="a-textInput__element" :class="{ '-animate': animateBorder }" placeholder=" ادخل كلمة مرور الحساب"
              name="password" type="password" v-model="password" />
            <div class="a-textInput__placeholder">{{ placeholder }}</div>
            <span class="a-textInput__pcAnimation" v-if="animateBorder"></span>
          </div>
        </div>
        
        <div  class="m-loginForm__group">
          <div v-if="salesmen == null" class="a-textInput">
          </div>   
          <div v-else class="a-textInput">
            <DxLookup :rtlEnable="true" placeholder = "اختر المستخدم" class="a-textInput__element" :items="salesmen" v-model="email" @value-changed="changevalue()">
            </DxLookup>
          </div>     
        </div>

        <div v-if="salesmen != null" class="m-loginForm__group">
          <div class="a-textInput">
            <input class="a-textInput__element" :class="{ '-animate': animateBorder }" placeholder="ادخل كلمة مرور المستخدم"
              name="password1" type="password" v-model="password1" />
            <div class="a-textInput__placeholder">{{ placeholder }}</div>
            <span class="a-textInput__pcAnimation" v-if="animateBorder"></span>
          </div>
        </div>

        <div v-if="checked_cloud == false" class="m-loginForm__group">
          <div class="a-textInput">
            <input class="a-textInput__element" :class="{ '-animate': animateBorder }" placeholder="ادخل عنوان المخدم"
              name="password1" type="text" v-model="ip2" />
            <div class="a-textInput__placeholder">{{ placeholder }}</div>
            <span class="a-textInput__pcAnimation" v-if="animateBorder"></span>
          </div>
        </div>
        <div class="toggle-switch m-2 textRTL">            
            <label class="switch">
              <input type="checkbox" v-model="checked_cloud">
              <span class="slider"></span>
            </label>
            <span class="label-text">{{ (checked_cloud) ? 'داتا سحابية' : 'داتا محلية' }}</span>            
        </div>   
        <submit-button >تسجيل الدخول</submit-button><br>

      </form>      
    </div>
  </div>

</template>
<style lang="scss" scoped>
@import "@/scss/components/inputs/_animatedInput.scss";
@import "@/scss/components/inputs/checkbox.scss";
</style>

<script>
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import Header from "../components/inputs/HeaderHeader.vue";
import axios from "axios";
//import AnimatedInput from "./inputs/AnimatedInput.vue";
//import CustomCheckbox from "./inputs/CustomCheckbox.vue";
//import LinkButton from "./buttons/LinkButton.vue";
import SubmitButton from "../components/buttons/SubmitButton.vue";
import { DeviceUUID } from 'device-uuid';
import { DxLookup } from 'devextreme-vue/lookup';
import LoadingOverlay from '../components/LoadingOverlay1.vue'

export default {
  data() {
    return {
      loading:false,
      url: '',
      ip: '',
      ip2:localStorage.getItem('ip2') == null ||  localStorage.getItem('ip2') == ''? 'http://localhost:9657/' : localStorage.getItem('ip2'),
      email: "",
      password: "",
      password1: "",
      username:"",
      checked_cloud:localStorage.getItem('BCloud')=='true' ? true : false ,
      salesmen:null,
      rememberMe: false,
      uid: new DeviceUUID().get(),
      IsLoging:false,
      submit: async () => {    
        console.log(this.username)
        console.log(this.password)
        console.log(this.email)
        console.log(this.password1)    
        if(this.IsLoging)
          return;        
        this.IsLoging = true;
        const fp = await FingerprintJS.load()
        const result = await fp.get()
        const visitorId = result.visitorId
        localStorage.setItem('BCloud',this.checked_cloud)
        var ip_ = this.ip;
        if(this.checked_cloud){
          ip_ = this.ip;
        }else{
          ip_ = this.ip2;
        }
 
        try{
          let response = () => {                  
          var u = this.username;
          var uEdari = this.email;
          var p = this.password;
          var pEdari = this.password1;
          var str = 'method%3DWEB_Login%26username%3D' + this.email + '%26password%3D' + this.password1 + '%26android_id%3D' + this.uid + '%26db_guid%3D' + localStorage.getItem('db_guid')+'%26SESSION%3D' + visitorId ;          
          if(this.checked_cloud){              
              console.log(this.loadingMessage);
              str = {Username:u,UsernameEdari:uEdari, Password:p , PasswordEdari:pEdari ,method:str,SESSION:visitorId};
          }else{                 
            str += '%26Ip%3D' + visitorId+ "%26usernameSubscribe%3D" + u + "%26passwordSubscribe%3D" + p;            
          }
          if(this.email == '' && this.password1 == '')
            this.loadingMessage2 = 'يتم جلب المستخدمين'
            else
            this.loadingMessage2 = 'جاري تسجيل الدخول'   
          this.loading = true;
          return new Promise(function (resolve) {
           
              axios.post(ip_ ,  str 
              ).then(response => {
                resolve(response);
              }).catch(error => {
                if (error.response) {
                  this.loadingMessage2="faild in response | "+ error.response.data; 
                  this.loading = false; 
                  this.loading = true; 
                  // السيرفر رد بخطأ (status code ليس 2xx)
                  //this.loadingMessage2="خطأ من السيرفر:";
                  console.error("خطأ من السيرفر:", error.response.data);
                } else if (error.request) {
                  this.loadingMessage2="faild in request | "+ error.response.data; 
                  this.loading = false; 
                  this.loading = true; 
                  console.error("لم يصل رد من السيرفر:", error.request);
                } else {
                  this.loadingMessage2="faild in network | "+ error.response.data; 
                  this.loading = false; 
                  this.loading = true; 
                  // خطأ في الشبكة أو الإعداد
                  //this.loadingMessage2="خطأ في الشبكة:";
                  console.error("خطأ في الشبكة:", error.message);
                }

                // مثال على التعامل مع ERR_CONNECTION_RESET
                if (error.code === "ECONNRESET") {
                  //this.loadingMessage2="الاتصال انقطع (Connection Reset). حاول مرة أخرى لاحقاً.";
                  console.error("الاتصال انقطع (Connection Reset). حاول مرة أخرى لاحقاً.");
                }
               resolve(error)
               setTimeout(() => {            
                  this.loading = false;
                  this.IsLoging = false;
                }, 1000); 
              });
          });
        };
        let responseData = await response();
        this.loadingMessage2=responseData.message;
        if (responseData.data[0]['State'] == true) {
          //console.log("YYTEYYYYY " + responseData.data[0]['db_guid'])
          if(responseData.data[0]['db_guid'] == ""){
            this.salesmen = [];
            if(responseData.data[0]["dataTable"].length > 0)
            for(let i = 0 ; i<responseData.data[0]["dataTable"].length;i++){
              this.salesmen.push(responseData.data[0]["dataTable"][i]["Name"]);
            }
           // this.email = this.salesmen[0];
           this.IsLoging = false;
           this.loading = false;
            return;
          }
          localStorage.setItem("db_guid", responseData.data[0]['db_guid']);
          localStorage.setItem("username", this.email);
          localStorage.setItem("password", this.password1);
          localStorage.setItem("ip", this.ip);
          localStorage.setItem("ip2", this.ip2);
          localStorage.setItem("username2", this.username);
          localStorage.setItem("password2", this.password);   
          localStorage.setItem("session", visitorId);          
          localStorage.setItem("token", responseData.data[0]["token"]);
          //this.loading = f; 
          this.loadingMessage2="تم تسجيل الدخول بنجاح"; 
          this.loading = false; 
          this.loading = true; 
          setTimeout(() => {          
            this.$router.push({ name: "Dashboard" });
            this.loading = false; 
          }, 1000);                    
          /*await this.$swal.fire({
            //  title: "Are you sure?",
            text: "تم تسجيل الدخول بنجاح",
            icon: "success",
            // iconHtml: "!",
            //showCancelButton: true,
            showConfirmButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "OK",
            timer: 1000
          }); */
                       
        } else {
          localStorage.clear();
          /*this.$swal.fire({
            text: responseData.data[0]["Response"],
            icon: "error",
            showConfirmButton: false,
            confirmButtonColor: "#d33",
            confirmButtonText: "OK",
            timer: 5000
          });*/
          this.loading = false;     
          this.loadingMessage2=responseData.data[0]["Response"];
          this.loading = true;                
          setTimeout(() => {            
            this.loading = false;
            this.IsLoging = false;
          }, 1000);          
        }
        }catch{          
          this.loading = false;      
          this.loading = true;      
          setTimeout(() => {            
            this.loading = false;
            this.IsLoging = false;
          }, 1000);        
        }
      }
    };
  },
  mounted() {
    
    fetch(`/config.json?ts=${Date.now()}`)
      .then(response => response.json())
      .then(data => {
        this.ip = data.link;
      })
      .catch(error => {
        console.error('Error loading the file:', error);
      });
    /*fetch(`/config2.json?ts=${Date.now()}`)
      .then(response => response.json())
      .then(data => {
        this.ip2 = data.link;
      })
      .catch(error => {
        console.error('Error loading the file:', error);
      });*/
  },  
  
  async created() {
   
  },
  components: {
    Header,
    DxLookup,
    SubmitButton,
    LoadingOverlay
  },
  props: {
    title: String
  }, method: {
    get_salesMen(){
    },
    login() {
    },   
  }
};
</script>

<style lang="scss" scoped>
.dark{
  background-color: black;
  color: white;
}
</style>